app.controller("AgentSearchController",
	["$rootScope", "$scope", "$http", "AgentSearchModel", function($rootScope, $scope, $http, AgentSearchModel) {
		AgentSearchModel.loading = false;
		$scope.errors = {};
		$rootScope.trackCity = null;

		String.prototype.capitalizeFirstLetter = function() {
			return this.charAt(0).toUpperCase() + this.slice(1);
		};

		$scope.search = function() {
			var errors = {
				postCode: 'Virheellinen postinumero',
				ageMin: 'Virheellinen ikä',
				ageMax: 'Virheellinen ikä'
			};
			AgentSearchModel.loading = true;
			if($scope.postCode) {
				$scope.city = '';
			}

			var city = $scope.city;
			var params = {
				name: $scope.name,
				degrees: $scope.degree,
				"language[]": $scope.languages,
				postCode: $scope.postCode,
				city: city ? city.capitalizeFirstLetter() : undefined,
				//"skills[]": $scope.skills || undefined,
				random: 1,
				notuples: 1
			};

			$http({
				method: "GET",
				url: "/api/km/KMSite/agentSearch",
				params: params
			})
			.then(function(result) {
				$scope.errors = {};
				AgentSearchModel.matches = result.data.data.agents;
				AgentSearchModel.agencies = result.data.data.agencies;
				if(AgentSearchModel.matches.length > 30) {
					AgentSearchModel.searchResults = AgentSearchModel.matches.slice(0,30);
					AgentSearchModel.manyresults = true;
				} else {
					AgentSearchModel.searchResults = AgentSearchModel.matches;
					AgentSearchModel.manyresults = false;
				}
				AgentSearchModel.loading = false;

				// If wakeHistory is loaded, track history for county/postcode
				if (window.wakeHistory) {
					if ($scope.postCode) {
						var firstAgent = result.data.data.agents[0] || {};
						if (firstAgent.homeAgency) {
							var firstAgency = result.data.data.agencies[firstAgent.homeAgency] || {};
							console.log('here');
							window.wakeHistory.trackHistory('seller-postcode', $scope.postCode);

							if (firstAgency.city) {
								window.wakeHistory.trackHistory('seller-county', firstAgency.city);
								$rootScope.trackCity = firstAgency.city;
							}
						}
					}
				}

				if (window.Utils) {
					var resultsContainer = document.querySelector('.b-agent-search-results') || null;
					if (resultsContainer) {
						Utils.ScrollTo('.b-agent-search-results', 80);
					}
				}

				_gaq.push(['_trackEvent', 'Välittäjähaku', 'Lähetä']);
			},
			function(result) {
				AgentSearchModel.matches = [];
				AgentSearchModel.agencies = [];
				AgentSearchModel.searchResults = [];
				AgentSearchModel.manyresults = false;
				AgentSearchModel.loading = false;
				// Get errors
				for(var key in result.data.data) {
					if(!result.data.data[key].success) {
						$scope.errors[key] = errors[key];
					} else {
						$scope.errors[key] = null;
					}
				}
			});
		};

		$scope.searchByType = function() {
			if (!$scope.typePostcode) {
				return $scope.errors.postcode = 'Postinumero on pakollinen.';
			}
			AgentSearchModel.loading = true;
			$scope.errors = {};

			var roomArray = [];
			for (var room in $scope.rooms) {
				if ($scope.rooms.hasOwnProperty(room) && $scope.rooms[room]) {
					roomArray.push(room);
				}
			}

			var params = {
				postcode: $scope.typePostcode,
				buildingType: $scope.housetype,
				"roomAmount[]": roomArray
			};
			$http({
				method: 'GET',
				url: '/api/km/KMSite/agentSearchBySales',
				params: params
			})
			.then(function(result) {
				$scope.errors = {};
				AgentSearchModel.matches = result.data.data.agents;
				AgentSearchModel.agencies = result.data.data.agencies;
				if(AgentSearchModel.matches.length > 30) {
					AgentSearchModel.searchResults = AgentSearchModel.matches.slice(0,30);
					AgentSearchModel.manyresults = true;
				} else {
					AgentSearchModel.searchResults = AgentSearchModel.matches;
					AgentSearchModel.manyresults = false;
				}
				AgentSearchModel.loading = false;
				// If wakeHistory is loaded, track history for county/postcode
				if (window.wakeHistory) {
					if ($scope.typePostcode) {
						window.wakeHistory.trackHistory('seller-postcode', $scope.typePostcode);
					}
					var firstAgent = result.data.data.agents[0] || {};
					if (firstAgent.homeAgency) {
						var firstAgency = result.data.data.agencies[firstAgent.homeAgency] || {};
						if (!$scope.typePostcode && firstAgency.postcode) {
							window.wakeHistory.trackHistory('seller-postcode', firstAgency.postcode);
						}
						if (firstAgency.city) {
							window.wakeHistory.trackHistory('seller-county', firstAgency.city);
							$rootScope.trackCity = firstAgency.city;
						}
					}
				}
				_gaq.push(['_trackEvent', 'Välittäjähaku', 'Lähetä']);
			}, 
			function(result) {
				AgentSearchModel.matches = [];
				AgentSearchModel.agencies = [];
				AgentSearchModel.searchResults = [];
				AgentSearchModel.manyresults = false;
				AgentSearchModel.loading = false;
				// Get errors
				for(var key in result.data) {
					if(!result.data[key].success) {
						$scope.errors[key] = errors[key];
					} else {
						$scope.errors[key] = null;
					}
				}
			});
		};
	}]
);